import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { ResetPasswordState } from './types';
import { endpoints, formatErrors, baseQuery } from 'utils/api/endpoints';
import {
  ResetPasswordRequest,
  AuthMessageData,
} from 'types/Auth';
import { ApiResponse } from 'types/ApiResponse';

export const initialState: ResetPasswordState = {
  loading: false,
  error: null,
  success: false,
};

export const slice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
      state.loading = false;
      if (action.payload) {
        state.error = null;
      }
    },
    reset: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const api = createApi({
  reducerPath: 'resetPasswordApi',
  baseQuery,
  tagTypes: ['ResetPassword'],
  endpoints: build => ({
    resetPassword: build.mutation<ApiResponse<AuthMessageData>, ResetPasswordRequest>({
      query: (resetData) => ({
        url: endpoints.resetPassword.url,
        method: endpoints.resetPassword.method,
        body: resetData,
      }),
      transformResponse: (response: ApiResponse<AuthMessageData>) => response,
    }),
  }),
});

export const useResetPasswordSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    // Reset Password API
    useResetPasswordMutation: api.useResetPasswordMutation,
    // Slice actions
    actions: slice.actions,
  };
};
